import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useCapexMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.CapexMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runCapexMetricConfigurationQueryV1: result.run,
		modelCapexMetricConfigurationQueryV1: result.model,
	}
}

export function useCostSubtotalMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.CostSubtotalMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runCostSubtotalMetricConfigurationQueryV1: result.run,
		modelCostSubtotalMetricConfigurationQueryV1: result.model,
	}
}

export function useExpenseMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.ExpenseMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runExpenseMetricConfigurationQueryV1: result.run,
		modelExpenseMetricConfigurationQueryV1: result.model,
	}
}

export function useMarginCogsMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.MarginCogsMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runMarginCogsMetricConfigurationQueryV1: result.run,
		modelMarginCogsMetricConfigurationQueryV1: result.model,
	}
}

export function useMetricsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.MetricsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runMetricsPageQueryV1: result.run,
		modelMetricsPageQueryV1: result.model,
	}
}

export function useOpexMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | null | Ref<string | null>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string | null>(metricId) ? metricId : ref<string | null>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.OpexMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runOpexMetricConfigurationQueryV1: result.run,
		modelOpexMetricConfigurationQueryV1: result.model,
	}
}

export function useResourceCostMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.ResourceCostMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runResourceCostMetricConfigurationQueryV1: result.run,
		modelResourceCostMetricConfigurationQueryV1: result.model,
	}
}

export function useResourceMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.ResourceMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runResourceMetricConfigurationQueryV1: result.run,
		modelResourceMetricConfigurationQueryV1: result.model,
	}
}

export function useRevenueMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.RevenueMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runRevenueMetricConfigurationQueryV1: result.run,
		modelRevenueMetricConfigurationQueryV1: result.model,
	}
}

export function useTotalCostMetricConfigurationQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, metricId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _metricId = isRef<string>(metricId) ? metricId : ref<string>(metricId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		metricId: _metricId,
		...useQuery(() => new q.TotalCostMetricConfigurationQueryV1(_workspaceId.value, _strategyId.value, _metricId.value))
	}
	return {
		...result,
		runTotalCostMetricConfigurationQueryV1: result.run,
		modelTotalCostMetricConfigurationQueryV1: result.model,
	}
}

